export default __webpack_public_path__ + "static/media/home_carousel_2.d148d743.jpg";